import { Form, Formik } from 'formik';
import React, { useState } from 'react';

import authApis from '../../../APIs/auth';
import { useRoot } from '../../../context/RootProvider';
import {
  Alert,
  Button,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import { requestAPI } from '../../../utils';
import { ActiveComponentType } from '.';
import { ActionButtonContainer, Container } from './onboardingForms.style';
import validation from './validation';

const CompanyDetails = ({
  setCurrentStep,
  initialState,
}: ActiveComponentType) => {
  const { updateAuth } = useRoot();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const handleGoBack = () => setCurrentStep((prev) => prev - 1);
  const handleContinue = async (values: typeof initialState) => {
    try {
      setErrorMessage('');
      setLoading(true);
      const onBoardingData = await requestAPI(
        authApis.onBoarding({
          companyDetails: {
            companyName: values.companyName,
          },
          onboardingStep: 3,
        })
      );
      setLoading(false);
      updateAuth(onBoardingData.user);
      setCurrentStep((prev) => prev + 1);
    } catch (error: any) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Container>
      <Typography variant="title" className="title">
        Company Details
      </Typography>
      {errorMessage && <Alert text={errorMessage} type="error" />}
      <Formik
        initialValues={initialState}
        enableReinitialize
        onSubmit={handleContinue}
        validationSchema={validation.companyDetails}
      >
        {({ values, setFieldValue, handleSubmit, touched, errors }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer
                label="Company Name"
                error={touched.companyName ? errors.companyName : ''}
                marginBottom="20px"
              >
                <Input
                  value={values.companyName || ''}
                  onChange={(e) => setFieldValue('companyName', e.target.value)}
                  placeholder="Company Name"
                />
              </FormContainer>

              <ActionButtonContainer>
                <Button
                  variant="gray"
                  width="93px"
                  onClick={handleGoBack}
                  isLoading={loading}
                >
                  Back
                </Button>
                <Button
                  variant="secondary"
                  width="120px"
                  htmlType="submit"
                  isLoading={loading}
                >
                  Continue
                </Button>
              </ActionButtonContainer>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default CompanyDetails;
